import React from 'react';
import { Box, Grid, CircularProgress, Typography } from '@mui/material';
import ProjectTile from '../ProjectTile';
import SearchBar from '../SearchBar';
import FilterPanel from '../FilterPanel';

const AdminProjectTiles = ({ projects, loading, searchQuery, onSearch, filters, onFilterChange, onUpdate }) => {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={8}>
        <CircularProgress />
      </Box>
    );
  }

  if (projects.length === 0) {
    return (
      <Box textAlign="center" py={8}>
        <Typography variant="h6" color="text.secondary">No projects in the system</Typography>
      </Box>
    );
  }

  return (
    <>
      <Box mb={3}>
        <SearchBar placeholder="Search projects..." onSearch={onSearch} defaultValue={searchQuery} />
      </Box>
      <Box mb={3}>
        <FilterPanel filters={filters} onFilterChange={onFilterChange} />
      </Box>
      <Grid container spacing={3}>
        {projects.map((project) => (
          <Grid item xs={12} md={6} key={project.id}>
            <ProjectTile project={project} onUpdate={onUpdate} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default AdminProjectTiles;
